import { Box, Stack, Typography } from "@mui/material"
import Image from "components/Image"
import React from "react"
import { useTranslation } from "react-i18next"
import { styles } from "./styles"

export default function UploadProgress({ progress = 0 }) {
  const { t } = useTranslation()
  return (
    <Box sx={styles.uploadBox}>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={styles.progressBox}
      >
        <Typography variant="span" sx={styles.infoText}>
          {t("Sending your audio files")}
        </Typography>
        <Typography variant="span" fontWeight={600} fontSize={14}>
          {`${progress}%`}
        </Typography>
      </Stack>
      <Box sx={styles.imageBox}>
        <Image
          src={require("assets/img/common/maestra-01.png")}
          width="130px"
          height="auto"
        />
      </Box>
    </Box>
  )
}
